export const generateIdentifier = (text: string, suffix?: string) => {
  const textWithoutExtension = (text ?? "").replace(/\.[^/.]+$/, "");

  // Replace spaces with underscores and convert to lowercase
  const transformedText = textWithoutExtension.replace(/\s+/g, "_").toLowerCase();

  // Append the suffix if provided
  return suffix ? `${transformedText}_${suffix}` : transformedText;
};
